export const postStatuses = {
  1: '已发布',
  2: '待审核',
  3: '草稿',
  4: '驳回',
  5: '垃圾箱'
}



// WEBPACK FOOTER //
// ./src/config/postStatuses.js